// Vendor imports
const _ = require('lodash')
const isURL = require('validator/lib/isURL')

// http://www.regular-expressions.info/unicode.html
// https://github.com/tc39/proposal-regexp-unicode-property-escapes
const VALID_URL_REGEXP = /([\p{Letter}\p{Nonspacing_Mark}\p{Punctuation}\p{Symbol}\p{Number}\s]|\p{Emoji_Modifier_Base}\p{Emoji_Modifier}?|\p{Emoji_Presentation}|\p{Emoji}\uFE0F)/gu

const RESERVED_MIX_NAMES = ['posts', 'mixes', 'mixed', 'collections', 'followers', 'following', 'friends']

function cleanName(name) {
  // replace captured multiple spaces with a single space
  if (name) {
    const cleanedName = name.trim()
      .replace(/\s+/ig, ' ')
      .replace(/(<([^>]+)>)/ig, '')
      .match(VALID_URL_REGEXP)

    return cleanedName ? cleanedName.join('') : ''
  }
  return name
}

function displayText(name) {
  return cleanName(name)
  .replace(/(?:^|\b)([a-z])(\S+)/gi, (_, first, rest) => first.toUpperCase() + rest)
  .replace(/\b(i)\b/g, () => 'I')
  .replace(/ (a|an|and|as|in|on|of|if|or|but|for|it|is|the|to|not|nor|with|because|that|than)\b/gi, (_, word) => {
    return ' ' + word.toLowerCase()
  })
}

function isValidMixName(name) {
  // https://github.com/mix/mix-wiki/wiki/Form-Validation
  // must be an alphanum string that doesn't collide with routes
  // CAN have special chars
  const trimmedName = _.isString(name) ? name.replace(/\s+/g, '') : ''
  return (
    trimmedName.length >= 2 &&
    trimmedName.length <= 50 &&
    trimmedName.match(VALID_URL_REGEXP) &&
    !nameContainsUrl(name) &&
    !trimmedName.match(/(<([^>]+)>)/ig) &&
    !RESERVED_MIX_NAMES.includes(_.toLower(trimmedName))
  )
}

function nameContainsUrl(name) {
  return _.chain(name)
          .split(' ')
          .map(val => isURL(val))
          .some()
          .value()
}

// prettyUrl generates unicode, seo friendly uri components
function prettyUrl(name) {
  return encodeURIComponent(
    cleanName(name).toLowerCase()
    .replace(/\\|\//g, ' ')
    .replace(/[\s\-]+/g, '-')
    .replace(/-?[.!%~*'()]$/, '_')
  ).toLowerCase()
}

module.exports = {
  cleanName,
  displayText,
  isValidMixName,
  prettyUrl
}
